import { render, staticRenderFns } from "./aed-pendingMove.vue?vue&type=template&id=0a5d5a1e&"
import script from "./aed-pendingMove.vue?vue&type=script&lang=js&"
export * from "./aed-pendingMove.vue?vue&type=script&lang=js&"
import style0 from "./aed-pendingMove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports